import { Box, Text,   Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,  Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Input,
    Select,
    AspectRatio, } from "@chakra-ui/react";
  import background from "../../assets/bg.jpg"
  import Menubar from "../../components/Menubar";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { addVideo, editVideo, getAllVideo } from "../../store/actionCreators/videoAction";
import { ACCENT_1_COLOR } from "../../constants/color";
  
  export default function VideoList() {
    const dispatch = useDispatch();
    const {video} = useSelector((store) => store.rootReducer.videoReducer)
    const [currentVideo, setCurrentVideo] = useState({});
    const [newVideoForm, setNewVideoForm] = useState({});
    const [editVideoId, setEditVideoId] = useState(0);
    const [editVideoForm, setEditVideoForm] = useState({});
    const {
      isOpen,
      onOpen,
      onClose,
    } = useDisclosure();

    const {
      isOpen: isOpenNew,
      onOpen: onOpenNew,
      onClose: onCloseNew,
    } = useDisclosure();
  
    const {
      isOpen: isOpenEdit,
      onOpen: onOpenEdit,
      onClose: onCloseEdit,
    } = useDisclosure();

    useEffect(() => {
      dispatch(getAllVideo())
    }, [dispatch])

    const videoList = useMemo(() => {
      const candidate = [];
      const mukyu = [];
      const gokyu = [];
      const yonkyu = [];
      const sankyu = [];
      const nikyu = [];
      const ikkyu = [];
      const shodan = [];
      const nidan = [];

      video.forEach((el) => {
        if (el.level === "Candidate") candidate.push(el);
        if (el.level === "Mukyu") mukyu.push(el);
        if (el.level === "Gokyu") gokyu.push(el);
        if (el.level === "Yonkyu") yonkyu.push(el);
        if (el.level === "Sankyu") sankyu.push(el);
        if (el.level === "Nikyu") nikyu.push(el);
        if (el.level === "Ikkyu") ikkyu.push(el);
        if (el.level === "Shodan") shodan.push(el);
        if (el.level === "Nidan") nidan.push(el);
      })
      return {
        candidate,
        mukyu,
        gokyu,
        yonkyu,
        sankyu,
        nikyu,
        ikkyu,
        shodan,
        nidan
      }
    }, [video])

    const handleSeeVideo = (video) => {
      setCurrentVideo(video)
      onOpen();
    }

    const handleCloseVideo = () => {
      setCurrentVideo({})
      onClose();
    }

    const handleOpenEdit = (video) => {
      let tempEditForm = {
      };
      if (video.name) tempEditForm.name = video.name;
      if (video.level) tempEditForm.level = video.level;
      if (video.link) tempEditForm.link = video.link;
      if (video.group) tempEditForm.group = video.group;
      if (video.style) tempEditForm.style = video.style;
      setEditVideoId(video.id)
      setEditVideoForm(tempEditForm);
      onOpenEdit();
    };

    const handleChange = (e) => {
      const value = e.target.value;
      const name = e.target.name;
  
      setNewVideoForm({ ...newVideoForm, [name]: value });
    };
  
    const handleCloseNew = () => {
      setNewVideoForm({});
      onCloseNew();
    };
  
    const handleCloseEdit = () => {
      setEditVideoForm({});
      onCloseEdit();
    };
  
    const handleChangeEditForm = (e) => {
      const value = e.target.value;
      const name = e.target.name;
  
      setEditVideoForm({ ...editVideoForm, [name]: value });
    };
  
    const addNewVideo = async () => {
      try {
        if (!(!newVideoForm.name || !newVideoForm.link || !newVideoForm.level || !newVideoForm.group || !newVideoForm.style )) {
          dispatch(addVideo(newVideoForm));
          handleCloseNew();
        }
      } catch (error) {
        console.log(error);
      }
    };
  
    const handleUpdateVideo = async () => {
      try {
        if (!(!editVideoForm.name || !editVideoForm.level || !editVideoForm.link  || !editVideoForm.group || !editVideoForm.style)) { 
          dispatch(editVideo(editVideoId, editVideoForm));
          handleCloseEdit();
        }
      } catch (error) {
        console.log(error);
      }
    };

    return (
      <Box display={"flex"} width={"100vw"} background={`transparent url(${background})`} bgRepeat={"repeat"} pb={"24px"}>
        <Box width={"100vw"}>
          <Menubar/>
          <Box width={"100vw"} px={{ base: "5vw", lg: "20vw" }} display={"flex"} flexDir={"column"} textAlign={"left"} mt={"18px"}>
            <Box display={"flex"} alignItems={"center"} justifyContent={"space-between"}>
              <Text textColor={ACCENT_1_COLOR} fontSize={"30px"}>Mugai Ryu Indonesia</Text>
              <Box
                as="button"
                w={"180px"}
                py={"8px"}
                border={`1px solid ${ACCENT_1_COLOR}`}
                color={ACCENT_1_COLOR}
                className="cormorant-garamond-normal"
                fontSize={"15px"}
                letterSpacing={"2px"}
                transition={"all 0.3s ease"}
                _hover={{
                  bg: ACCENT_1_COLOR,
                  color: "#F7F5F0",
                }}
                onClick={() => onOpenNew()}
              >
                Add New Video
              </Box>
            </Box>
              
              <Text textColor={"#765946"} fontStyle={"italic"} fontSize={"18px"} mb={"24px"}>Kata Lessons List</Text>

              <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>Candidate</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                    <Th w={"240px"} color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Group</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Style</Th>
                    <Th w={"250px"} color={ACCENT_1_COLOR} textAlign={"center"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList?.candidate?.length > 0 && videoList?.candidate?.map((el) => <Tr>
                    <Td>{el.level}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.group}</Td>
                    <Td>{el.style}</Td>
                    <Td w={"250px"}>
                      <Box
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleSeeVideo(el)}
                      >
                        See Video
                      </Box>
                      <Box
                        mx={"12px"}
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>)}
                </Tbody>
              </Table>

              <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>Mukyu</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                    <Th w={"240px"} color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Group</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Style</Th>
                    <Th w={"250px"} color={ACCENT_1_COLOR} textAlign={"center"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList?.mukyu?.length > 0 && videoList?.mukyu?.map((el) => <Tr>
                    <Td>{el.level}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.group}</Td>
                    <Td>{el.style}</Td>
                    <Td w={"250px"}>
                      <Box
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleSeeVideo(el)}
                      >
                        See Video
                      </Box>
                      <Box
                        mx={"12px"}
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>)}
                </Tbody>
              </Table>

              <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>Gokyu</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                    <Th w={"240px"} color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Group</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Style</Th>
                    <Th w={"250px"} color={ACCENT_1_COLOR} textAlign={"center"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList?.gokyu?.length > 0 && videoList?.gokyu?.map((el) => <Tr>
                    <Td>{el.level}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.group}</Td>
                    <Td>{el.style}</Td>
                    <Td w={"250px"}>
                      <Box
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleSeeVideo(el)}
                      >
                        See Video
                      </Box>
                      <Box
                        mx={"12px"}
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>)}
                </Tbody>
              </Table>

              <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>Yonkyu</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                    <Th w={"240px"} color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Group</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Style</Th>
                    <Th w={"250px"} color={ACCENT_1_COLOR} textAlign={"center"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList?.yonkyu?.length > 0 && videoList?.yonkyu?.map((el) => <Tr>
                    <Td>{el.level}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.group}</Td>
                    <Td>{el.style}</Td>
                    <Td w={"250px"}>
                      <Box
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleSeeVideo(el)}
                      >
                        See Video
                      </Box>
                      <Box
                        mx={"12px"}
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>)}
                </Tbody>
              </Table>

              <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>Sankyu</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                    <Th w={"240px"} color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Group</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Style</Th>
                    <Th w={"250px"} color={ACCENT_1_COLOR} textAlign={"center"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList?.sankyu?.length > 0 && videoList?.sankyu?.map((el) => <Tr>
                    <Td>{el.level}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.group}</Td>
                    <Td>{el.style}</Td>
                    <Td w={"250px"}>
                      <Box
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleSeeVideo(el)}
                      >
                        See Video
                      </Box>
                      <Box
                        mx={"12px"}
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>)}
                </Tbody>
              </Table>

              <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>Nikyu</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                    <Th w={"240px"} color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Group</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Style</Th>
                    <Th w={"250px"} color={ACCENT_1_COLOR} textAlign={"center"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList?.nikyu?.length > 0 && videoList?.nikyu?.map((el) => <Tr>
                    <Td>{el.level}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.group}</Td>
                    <Td>{el.style}</Td>
                    <Td w={"250px"}>
                      <Box
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleSeeVideo(el)}
                      >
                        See Video
                      </Box>
                      <Box
                        mx={"12px"}
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>)}
                </Tbody>
              </Table>

              <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>Ikkyu</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                    <Th w={"240px"} color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Group</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Style</Th>
                    <Th w={"250px"} color={ACCENT_1_COLOR} textAlign={"center"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList?.ikkyu?.length > 0 && videoList?.ikkyu?.map((el) => <Tr>
                    <Td>{el.level}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.group}</Td>
                    <Td>{el.style}</Td>
                    <Td w={"250px"}>
                      <Box
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleSeeVideo(el)}
                      >
                        See Video
                      </Box>
                      <Box
                        mx={"12px"}
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>)}
                </Tbody>
              </Table>

              <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>Shodan</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                    <Th w={"240px"} color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Group</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Style</Th>
                    <Th w={"250px"} color={ACCENT_1_COLOR} textAlign={"center"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList?.shodan?.length > 0 && videoList?.shodan?.map((el) => <Tr>
                    <Td>{el.level}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.group}</Td>
                    <Td>{el.style}</Td>
                    <Td w={"250px"}>
                      <Box
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleSeeVideo(el)}
                      >
                        See Video
                      </Box>
                      <Box
                        mx={"12px"}
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>)}
                </Tbody>
              </Table>

              <Text textColor={ACCENT_1_COLOR} fontSize={"24px"}>Nidan</Text>
              <Table mb={"24px"}>
                <Thead>
                  <Tr>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Level</Th>
                    <Th w={"240px"} color={ACCENT_1_COLOR} textAlign={"center"}>Name</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Group</Th>
                    <Th w={"120px"} color={ACCENT_1_COLOR} textAlign={"center"}>Style</Th>
                    <Th w={"250px"} color={ACCENT_1_COLOR} textAlign={"center"}></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {videoList?.nidan?.length > 0 && videoList?.nidan?.map((el) => <Tr>
                    <Td>{el.level}</Td>
                    <Td>{el.name}</Td>
                    <Td>{el.group}</Td>
                    <Td>{el.style}</Td>
                    <Td w={"250px"}>
                      <Box
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleSeeVideo(el)}
                      >
                        See Video
                      </Box>
                      <Box
                        mx={"12px"}
                        as="button"
                        py={"8px"}
                        px={"8px"}
                        border={`1px solid ${ACCENT_1_COLOR}`}
                        color={ACCENT_1_COLOR}
                        className="cormorant-garamond-normal"
                        fontSize={"15px"}
                        letterSpacing={"2px"}
                        transition={"all 0.3s ease"}
                        _hover={{
                          bg: ACCENT_1_COLOR,
                          color: "#F7F5F0",
                        }}
                        onClick={() => handleOpenEdit(el)}
                      >
                        Edit
                      </Box>
                    </Td>
                  </Tr>)}
                </Tbody>
              </Table>
          </Box>

          {/* VIEW VIDEO MODAL */}
          <Modal
          isOpen={isOpen}
          onClose={handleCloseVideo}
          isCentered
          closeOnOverlayClick={false}
          size={"xl"}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader color={ACCENT_1_COLOR}>
              {currentVideo?.group} - {currentVideo?.name}
            </ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={"24px"}>
              <AspectRatio width={"100%"} ratio={16/9}>
                <iframe
                  title={currentVideo.name}
                  src={currentVideo.link}
                  allowFullScreen
                />
              </AspectRatio>
            </ModalBody>
          </ModalContent>
        </Modal>

          {/* REGISTER NEW KENSHI MODAL */}
        <Modal
          isOpen={isOpenNew}
          onClose={handleCloseNew}
          isCentered
          closeOnOverlayClick={false}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader textColor={ACCENT_1_COLOR}>Add New Video</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
            <Box>
                <Text textColor={ACCENT_1_COLOR}>Name</Text>
                <Input
                  placeholder="Video name"
                  name="name"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>
            <Box>
              
                <Text textColor={ACCENT_1_COLOR}>Level</Text>
                <Select
                  placeholder="Video Level"
                  name="level"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="Candidate">Candidate</option>
                  <option value="Mukyu">Mukyu</option>
                  <option value="Gokyu">Gokyu</option>
                  <option value="Yonkyu">Yonkyu</option>
                  <option value="Sankyu">Sankyu</option>
                  <option value="Nikyu">Nikyu</option>
                  <option value="Ikkyu">Ikkyu</option>
                  <option value="Shodan">Shodan</option>
                  <option value="Nidan">Nidan</option>
                </Select>
              </Box>
              <Box>
                <Text textColor={ACCENT_1_COLOR}>Group</Text>
                <Input
                  placeholder="Kata Group"
                  name="group"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>
              <Box>
                <Text textColor={ACCENT_1_COLOR}>Style</Text>
                <Select
                  placeholder="Kata Style"
                  name="style"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="Tachi">Tachi</option>
                  <option value="Zagi">Zagi</option>
                </Select>
              </Box>
              <Box>
                <Text textColor={ACCENT_1_COLOR}>Link</Text>
                <Input
                  placeholder="Video link"
                  name="link"
                  onChange={(e) => handleChange(e)}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>
            </ModalBody>

            <ModalFooter>
              <Box
                as="button"
                py={"8px"}
                px={"12px"}
                border={`1px solid ${ACCENT_1_COLOR}`}
                color={ACCENT_1_COLOR}
                className="cormorant-garamond-normal"
                fontSize={"15px"}
                letterSpacing={"2px"}
                transition={"all 0.3s ease"}
                _hover={!(!newVideoForm.name || !newVideoForm.link || !newVideoForm.level || !newVideoForm.group || !newVideoForm.style ) ? {
                  bg: ACCENT_1_COLOR,
                  color: "#F7F5F0",
                } : {cursor: "not-allowed", opacity: 0.6}}
                onClick={addNewVideo}
              >
                Register
              </Box>
            </ModalFooter>
          </ModalContent>
        </Modal>

        {/* EDIT KENSHI PROFILE MODAL */}
        <Modal
          isOpen={isOpenEdit}
          onClose={handleCloseEdit}
          isCentered
          closeOnOverlayClick={false}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader textColor={ACCENT_1_COLOR}>Edit Video Profile</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box>
                <Text textColor={ACCENT_1_COLOR}>Name</Text>
                <Input
                  placeholder="Video name"
                  name="name"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editVideoForm.name}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>

              <Box>
                <Text textColor={ACCENT_1_COLOR}>Level</Text>
                <Select
                  placeholder="Video Level"
                  name="level"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editVideoForm.level}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="Candidate">Candidate</option>
                  <option value="Mukyu">Mukyu</option>
                  <option value="Gokyu">Gokyu</option>
                  <option value="Yonkyu">Yonkyu</option>
                  <option value="Sankyu">Sankyu</option>
                  <option value="Nikyu">Nikyu</option>
                  <option value="Ikkyu">Ikkyu</option>
                  <option value="Shodan">Shodan</option>
                  <option value="Nidan">Nidan</option>
                </Select>
              </Box>

              <Box>
                <Text textColor={ACCENT_1_COLOR}>Group</Text>
                <Input
                  placeholder="Kata Group"
                  name="group"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editVideoForm.group}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>

              <Box>
                <Text textColor={ACCENT_1_COLOR}>Style</Text>
                <Select
                  placeholder="Kata Style"
                  name="style"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editVideoForm.style}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                >
                  <option value="Tachi">Tachi</option>
                  <option value="Zagi">Zagi</option>
                </Select>
              </Box>

              <Box>
                <Text textColor={ACCENT_1_COLOR}>Link</Text>
                <Input
                  placeholder="Video Link"
                  name="link"
                  onChange={(e) => handleChangeEditForm(e)}
                  value={editVideoForm.link}
                  _focus={{ boxShadow: "none", borderColor: ACCENT_1_COLOR }}
                ></Input>
              </Box>


            </ModalBody>

            <ModalFooter>
              <Box
                as="button"
                py={"8px"}
                px={"12px"}
                border={`1px solid ${ACCENT_1_COLOR}`}
                color={ACCENT_1_COLOR}
                className="cormorant-garamond-normal"
                fontSize={"15px"}
                letterSpacing={"2px"}
                transition={"all 0.3s ease"}
                _hover={!(!editVideoForm.name || !editVideoForm.level || !editVideoForm.link  || !editVideoForm.group || !editVideoForm.style) ? {
                  bg: ACCENT_1_COLOR,
                  color: "#F7F5F0",
                } : {cursor: "not-allowed", opacity: 0.6}}
                onClick={handleUpdateVideo}
              >
                Confirm Edit
              </Box>
            </ModalFooter>
          </ModalContent>
        </Modal>
        </Box>
      </Box>
    );
  }
  